import {forms as pohForms} from '@mc/poh';
import {Loader} from 'mc/lib';
import PrehledPlatbaApi from 'mc/lib/api/gen/pohledavky/PrehledPlatbaApi';
import BankaPoukazApi from 'mc/lib/api/gen/banky/BankaPoukazApi';
import PokladnaPoukazApi from 'mc/lib/api/gen/pokladny/PokladnaPoukazApi';
import {DetailActions} from 'mc/lib/detail';
import {SimpleListActions} from 'mc/lib/list';
import {ModalActions} from 'mc/lib/modal';
import React from 'react';
import CustomBankaPoukazApi from '../api/BankaPoukazApi';
import VratkaForm from '../components/form/VratkaForm';
import {postDokoncidDokladPoukazMessage} from '../utils/messageUtils';
import {isVypisRadek} from '../utils/platbyUtils';
import {invalidatePlatby} from './platbaListActions';
import * as TypVratky from 'mc/lib/api/gen/proxioapi/TypVratky';
import {toastr} from 'react-redux-toastr';
import {invalidateCurrentZadost, ZADOST_AREA} from "./zadostActions";

export const PLATBA_AREA = "platba";
export const PLATBA_VYROVNANI_LIST_AREA = "platbaVyrovnaniList";
export const PLATBA_VRATKA_LIST_AREA = "platbaVratkaList";

export function fetchPlatbaIfNeeded(id, force = false) {
    return DetailActions.fetchIfNeeded(PLATBA_AREA, id, () => PrehledPlatbaApi.getPrehledPlatbaById(id), force);
}

export function fetchPlatbaVyrovnaniIfNeeded(id, force = false) {
    return SimpleListActions.fetchIfNeeded(PLATBA_VYROVNANI_LIST_AREA, id, () => PrehledPlatbaApi.findVyrovnaniByPlatba(id), force);
}

export function fetchPlatbaVratkyIfNeeded(id, force = false) {
    return SimpleListActions.fetchIfNeeded(PLATBA_VRATKA_LIST_AREA, id, () => PrehledPlatbaApi.findVratkyByPlatba(id), force);
}

export function invalidatePlatbaVratky(id) {
    return DetailActions.invalidate(PLATBA_VRATKA_LIST_AREA, id);
}

export function invalidatePlatba(id) {
    return DetailActions.invalidate(PLATBA_AREA, id);
}

export function vyraditZeZpracovani(platba) {
    return dispatch => {
        return PrehledPlatbaApi.vyraditZeZpracovani(platba.id).then(() => {
            dispatch(invalidatePlatby());
            dispatch(invalidatePlatba(platba.id));
        });
    }
}

export function zaraditDoZpracovani(platba) {
    return dispatch => {
        return PrehledPlatbaApi.zaraditDoZpracovani(platba.id).then(() => {
            dispatch(invalidatePlatby());
            dispatch(invalidatePlatba(platba.id));
        });
    }
}

export function showVratitPrevodemModal(platba) {
    return showVratitModal(platba, {
        cisloUctuVisible: true,
        cisloUctuDisabled: isVypisRadek(platba),
        onSubmit: data => PrehledPlatbaApi.vratitBankou(platba.id, data),
        onSubmitSuccess: poukazHlavickaId => {
            window.open(CustomBankaPoukazApi.getDokumentPoukazu(poukazHlavickaId), '_blank');
        },
    });
}

export function showVratitHotoveModal(platba) {
    return showVratitModal(platba, {
        cisloUctuVisible: false,
        onSubmit: data => PrehledPlatbaApi.vratitHotove(platba.id, data),
        onSubmitSuccess: poukazHlavickaId => postDokoncidDokladPoukazMessage(poukazHlavickaId),
    });
}

function showVratitModal(platba, {cisloUctuVisible, cisloUctuDisabled, onSubmit, onSubmitSuccess}) {
    return dispatch => {
        const maxVratkaPromise = PrehledPlatbaApi.getMaxNovaVratkaNerealizovana(platba.id);
        dispatch(ModalActions.showAsyncWaiting('Načítání dat', <Loader/>, maxVratkaPromise, maxVratka => {
            if (maxVratka <= 0) {
                toastr.warning('Platbu není možné vrátit.');
                return;
            }
            const formProps = {
                initialValues: {
                    cisloUctu: cisloUctuVisible ? platba.cisloUctu : undefined,
                    castka: maxVratka,
                    datumSplatnosti: new Date(),
                },
                onSubmit,
                onSubmitSuccess: result => {
                    dispatch(ModalActions.hide());
                    dispatch(invalidatePlatby());
                    dispatch(invalidatePlatba(platba.id));
                    onSubmitSuccess(result);
                },
                cisloUctuVisible,
                cisloUctuDisabled,
                maxVratka,
            };
            dispatch(ModalActions.show(VratkaForm, formProps, 'Vrátit', {'size': 'sm'}));
        }));
    };
}

export function showVyrovnaniModal(platba, refresh, history) {
    return ModalActions.show(pohForms.PridaniVyrovnaniForm, {
        zbyva: platba.castkaZbyvaVyrovnat,
        submitLabel: 'Vyrovnat',
        onSubmit: ({pripad, castka}, dispatch) => {
            const vyrovnaniParams = {pripadId: pripad.id, castka};
            return PrehledPlatbaApi.vyrovnatPlatbu(platba.id, vyrovnaniParams).then(idPlatba => {
                dispatch(ModalActions.hide());
                dispatch(invalidatePlatby());
                dispatch(invalidatePlatba(platba.id));
                dispatch(invalidatePlatbaVratky(platba.id))
                if (refresh) {
                    dispatch(invalidatePlatba(idPlatba));    // nova platba u radku vypisu
                }
                if (history) {
                    history.push('/platba/' + idPlatba)
                }
            });
        },
    }, 'Vyrovnání');
}

export function zrusitVyrovnani(platba, pripad) {
    return dispatch => {
        PrehledPlatbaApi.zrusitVyrovnani(platba.id, pripad.id).then(() => {
            dispatch(invalidatePlatba(platba.id));
            dispatch(invalidateCurrentZadost());
        });
    };
}

export function tisknoutVratku(platba, vratka) {
    window.open(CustomBankaPoukazApi.getDokumentPoukazu(vratka.poukazHlavickaId), '_blank');
    return invalidatePlatba(platba.id);
}

export function stornovatVratku(platba, vratka) {
    return dispatch => {
        doStornovatVratku(vratka).then(() => {
            dispatch(invalidatePlatba(platba.id));
        });
    }
}

export function doStornovatVratku(vratka) {
    switch (vratka.typ) {
        case TypVratky.BANKA:
            return BankaPoukazApi.stornujPolozkuPoukazu(vratka.poukazPolozkaId);

        case TypVratky.POKLADNA:
            return PokladnaPoukazApi.stornujPolozkuPoukazu(vratka.poukazPolozkaId);

        default:
            throw new Error(`Neošetřený typ vratky ${vratka.typ}`);
    }
}
